import { addTeamFail, addTeamSuccess } from './actions';
import { put } from 'redux-saga/effects';
import {
    makeErrorPayload,
    makeSuccessPayload
} from '../../../../../../shared/helpers/payload.helper';
import {
    setErrorToast,
    setSuccessToast
} from '../../../../../../shared/toast/redux/actions';
import { fetchTeams } from '../teams-list/actions';
import { addTeam } from '../team.backend';

export function* addTeamSaga(action) {
    try {
        const response = yield addTeam(action.payload);
        yield put(addTeamSuccess(response.data));
        yield put(setSuccessToast(makeSuccessPayload('Team created.')));
        yield put(fetchTeams());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(addTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
